export default __webpack_public_path__ + "static/users4-dd959f74a44fec8c72917fdd471b1cd5.png";